import React, { useState, useEffect } from 'react';
import ProductCard from '../../components/ProductCard';
import { Product } from '../../types/types';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

interface ProductListProps {
  products: Product[];
  formatNumber: (number: number | bigint) => string;
  title: string;
  sub_title: string;
  productstext: string;
}

export default function ProductList({
  products,
  formatNumber,
  title,
  productstext,
  sub_title,
}: ProductListProps) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767); // 모바일 사이즈 기준
    };

    handleResize(); // 초기값 설정
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <section className="mt-[52px] mobile:mt-8 mb-[50px] w-full min-h-[600px] mobile:min-h-[400px]">
      <div className="items-center mb-6 px-4 mobile:px-0 mobile:mb-2">
        <div className="flex gap-2">
          <h1 className="Pretendard-Bold text-4xl mobile:text-lg text-[#414042]">
          {title}
          </h1>
          <h1 className="Pretendard-Bold text-4xl mobile:text-lg text-[#414042]">
            {productstext}
          </h1>
        </div>
      </div>

      {products.length === 0 ? (
        <div className="text-center h-[400px] mobile:h-[300px] flex justify-center Pretendard-Regular items-center text-lg mobile:text-sm text-[#414042] mt-4">
          등록된 상품이 없습니다.
        </div>
      ) : isMobile ? (
        <div className="grid grid-cols-3 mobile:grid-cols-2 gap-1">
          {products.slice(0, 6).map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              formatNumber={formatNumber}
            />
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-5 gap-6 px-4">
          {products.slice(0, 10).map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              formatNumber={formatNumber}
            />
          ))}
        </div>
      )}
    </section>
  );
}
